import {Extension} from "@tiptap/core";
import {Suggestion} from "@tiptap/suggestion";
import {PluginKey} from "prosemirror-state";

export const PopupCardPlus = Extension.create({
    name: 'popupCardPlus',

    /*
    addKeyboardShortcuts() {
        return {
            '@': () => {
                //删除这一个字符
                setTimeout(()=>{
                    // const $from = this.editor.state.selection.$from,
                    //     start = $from.start(),
                    //     end = $from.pos;
                    // const tr = this.editor.commands.deleteRange({from:(end-1), to:end});
                    //下面这个...
                    window.showPopupCardList(this.editor);
                },10)
            },
            // '[': () => {
            //     //删除这一个字符
            //     setTimeout(()=>{
            //         const $from = this.editor.state.selection.$from,
            //             start = $from.start(),
            //             end = $from.pos;
            //         // const tr = this.editor.commands.deleteRange({from:(end-1), to:end});
            //         window.showPopupCardList(this.editor);
            //     },10)
            // }
        }
    }*/
})